import { Button, Flex, Text } from '@chakra-ui/react'

import Card from 'components/Card/Card'
import CardHeader from 'components/Card/CardHeader'
import DataTableCard from 'components/DataTableCard'
import UsersTable from './UsersTable'

import Layout from 'components/ManagerLayout'
import { Link } from 'react-router-dom'

const Users = () => {
    return (
        <Layout>
            <Card>
                <CardHeader>
                    <Flex w="full" justifyContent="space-between" alignItems="center">
                        <Text>Usuários</Text>
                        <Link to="cadastrar">
                            <Button colorScheme="green" size="md">Cadastrar Usuário</Button>
                        </Link>
                    </Flex>
                </CardHeader>
                <DataTableCard>
                    <UsersTable />
                </DataTableCard>
            </Card>
        </Layout>
    )
}

export default Users